import React, { Dispatch, SetStateAction } from "react";
import styled from "styled-components";
import RadioBtn from "../../../../../Button/RadioBtn";
import Flex from "../../../../../DefaultStyles/Flex";
import { Input } from "../../../../../Input/Input";
import { ModalRow } from "../../../../Users/UserDetail/BlackListModal/BlackListModal";
import { ModalLabel } from "../../../../Users/UserDetail/CommentModal/TargetContainer";

interface PopupButtonSectionProps {
  button: {
    yes: boolean;
    no: boolean;
  };
  setButton: Dispatch<
    SetStateAction<{
      yes: boolean;
      no: boolean;
    }>
  >;
  buttonName: string;
  setButtonName: Dispatch<SetStateAction<string>>;
  buttonLink: string;
  setButtonLink: Dispatch<SetStateAction<string>>;
  appButtonLink: string;
  setAppButtonLink: Dispatch<SetStateAction<string>>;
  modalType?: string;
}

export default function PopupButtonSection({
  button,
  setButton,
  buttonName,
  setButtonName,
  buttonLink,
  setButtonLink,
  modalType,
  appButtonLink,
  setAppButtonLink,
}: PopupButtonSectionProps) {
  return (
    <>
      <ModalLabel style={{ marginBottom: 10 }}>버튼명 선택</ModalLabel>

      <Flex gapSize={55}>
        <RadioBtn
          label="확인"
          check={button.yes}
          clickEvent={() => {
            setButton({
              yes: !button.yes,
              no: false,
            });
          }}
          noTooltip
          disabled={modalType === "view"}
        />

        <RadioBtn
          label="직접 입력"
          check={button.no}
          clickEvent={() => {
            setButton({
              no: !button.no,
              yes: false,
            });
          }}
          noTooltip
          disabled={modalType === "view"}
        />
      </Flex>

      {button?.no && (
        <ButtonInputColumn>
          <ModalRow style={{ justifyContent: "space-between" }}>
            <ModalLabel>버튼명 입력</ModalLabel>

            <Input
              placeholder="직접 입력"
              value={buttonName}
              onChange={(e) => setButtonName(e.target.value)}
              style={{ width: 300 }}
              disabled={modalType === "view"}
            />
          </ModalRow>

          <ModalRow style={{ justifyContent: "space-between" }}>
            <ModalLabel>버튼 링크 추가(웹)</ModalLabel>

            <Input
              placeholder="웹 버튼 링크 입력(선택)"
              value={buttonLink}
              onChange={(e) => setButtonLink(e.target.value)}
              style={{ width: 300 }}
              disabled={modalType === "view"}
            />
          </ModalRow>

          <ModalRow style={{ justifyContent: "space-between" }}>
            <ModalLabel>버튼 링크 추가(앱)</ModalLabel>

            <Input
              placeholder="앱 버튼 링크 입력(선택)"
              value={appButtonLink}
              onChange={(e) => setAppButtonLink(e.target.value)}
              style={{ width: 300 }}
              disabled={modalType === "view"}
            />
          </ModalRow>
        </ButtonInputColumn>
      )}
    </>
  );
}

const ButtonInputColumn = styled.div`
  margin: 28px 0 60px 0;
`;
